<template>
<div>
  <b-card header="Vendas">
    <Grid name="filterGridProducts" ref="filterGridProducts" v-bind:url="url" v-bind:columns="columns" :pageable='true'  :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields" v-bind:preload="preload"></Grid>
  </b-card>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
export default {
  name: 'Products',
  components: {
    Grid
  },
  data() {
    return {
      preload: [],
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'updated_at': {
          type: 'date'
        },
        'date_sold': {
          type: 'date'
        },
        'quantity': {
          type: 'number'
        },
        'gsv': {
          type: 'number'
        },
        'niv': {
          type: 'number'
        },
        'liters': {
          type: 'number'
        }
      },
      url: 'tables/sales',
      columns: [{
        field: 'date_sold',
        title: 'Data',
        format: '{0:dd/MM/yyyy}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy'
            })
          }
        }
      }, {
        width: '160px',
        field: 'codle',
        title: 'Código LE'
      }, {
        width: '120px',
        field: 'sku',
        title: 'SKU'
      }, {
        width: '160px',
        field: 'quantity',
        title: 'Quantidade'
      }, {
        width: '160px',
        field: 'liters',
        title: 'Litros'
      }, {
        width: '160px',
        field: 'gsv',
        title: 'GSV'
      }, {
        width: '160px',
        field: 'niv',
        title: 'NIV'
      }, {
        field: 'updated_at',
        title: 'Atualizado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }, {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  }
}
</script>



// WEBPACK FOOTER //
// sales.vue?aae4446a